export * from './MailIcon';
export * from './MailIcon16Light';
export * from './MailIcon16Regular';
export * from './MailIcon16Solid';
export * from './MailIcon20Light';
export * from './MailIcon20Regular';
export * from './MailIcon20Solid';
export * from './MailIcon24Regular';
export * from './MailIcon24Solid';
export * from './MailIcon32Regular';
export * from './MailIcon64Regular';
